<script>
import { ref, watch } from '@vue/composition-api'
import { ADVANCED_SETTINGS_OPTIONS } from '@/constants/advancedSettings'
import { useUserStore } from '@/stores/UserStore'
import api from '@/api'
import { showSnackbar } from '@/actions'
import { showImportExportDialog } from '@/actions'
import GroupSplitting from '@/components/advancedSettings/sections/group-splitting.vue'
import StabilityPatterns from '@/components/advancedSettings/sections/stability-patterns.vue'
import StackIndex from '@/components/advancedSettings/sections/stack-index.vue'
import GroupCodes from '@/components/advancedSettings/sections/group-codes.vue'

export default {
  name: 'AdvancedSettingsForm',
  components: {
    GroupCodes,
    StackIndex,
    StabilityPatterns,
    GroupSplitting,
  },
  setup() {
    const userStore = useUserStore()
    const settings = ref({
      group_splitting:
        userStore.settings?.group_splitting ??
        ADVANCED_SETTINGS_OPTIONS.GROUP_SPLITTING_OPTIONS.ALLOWED.value,
      stability_pattern:
        userStore.settings?.stability_pattern ??
        ADVANCED_SETTINGS_OPTIONS.STABILITY_PATTERNS_OPTIONS.OPTIMAL.value,
      stack_index_enabled: !!userStore.settings?.stack_index_enabled,
      group_codes_enabled: !!userStore.settings?.group_codes_enabled,
      load_in_layers: !!userStore.settings?.load_in_layers,
      min_util_for_layers: userStore.settings?.min_util_for_layers ?? 0,
    })

    watch(
      settings,
      (newVal) => {
        api
          .patch('/settings', newVal)
          .then((response) => {
            userStore.setSettings(response.data)
            showSnackbar('Updated advanced settings!')
          })
          .catch(() => {
            showSnackbar(
              'Something went wrong updating the advanced settings',
              'Please check the form for errors.',
              'error'
            )
          })
      },
      { deep: true }
    )

    return {
      settings,
      showImportExportDialog,
    }
  },
}
</script>

<template>
  <div class="advancedSettingsForm">
    <group-splitting v-model="settings.group_splitting" />
    <stability-patterns v-model="settings" />
    <stack-index v-model="settings.stack_index_enabled" />
    <group-codes v-model="settings.group_codes_enabled" />
  </div>
</template>

<style scoped>
.advancedSettingsForm {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
